import React, { useRef, useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';

import { Modal } from '../../custom-essentials';
import LessonsBodyFooter from './LessonsBF';
import { checkResponse } from '../../form';

import {
    fetchLessonsId,
    createLesson,
    updateLesson,
    deleteLesson
} from '../../../actions';

const initDate = new Date();
initDate.setHours(0, 0, 0, 0);

function LessonModal(props){
    const mounted = useRef(false);
    useEffect(() => {
        mounted.current = true;
        return () => (mounted.current = false);
    });

    const [showModal, setShowModal] = useState(true);
    const [loaded, setLoaded] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    
    const [lesson, setLesson] = useState({});

    const { mode, onSubmitCallback, selectedLesson, fetchLessonsId, createLesson, updateLesson, deleteLesson } = props;

    useEffect(() => {
        async function init(){
            if(mode !== 'create'){
                const lessonsRes = await fetchLessonsId({ id: selectedLesson.id });
                const newLesson = lessonsRes.data?.[0] || {};
    
                const lessonMeta = [];
                if(newLesson.created_by) lessonMeta.push(newLesson.created_by);
                if(newLesson.updated_by) lessonMeta.push(newLesson.updated_by);

                if(mounted.current) setLesson(newLesson);
            }

            if(mounted.current) setLoaded(true);
        };
        init();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const handleClose = useCallback((changes) => {
        if(changes !== true) changes = false;
        async function close(){
            await onSubmitCallback(changes);
            if(mounted.current) setShowModal(false);
        }
        close();
    }, [onSubmitCallback]);

    const handleSubmit = useCallback((values, actions) => {
        async function submit(){
            const { setStatus, setSubmitting } = actions;
            
            let response = { status: 999 };
            
            if(['create', 'edit'].includes(mode)){
                const lessonParams = {
                    lessonId: values.lessonId,
                    name: values.name,
                    lessonLength: values.lessonLength || 0,
                    defaultSortOrder: values.defaultSortOrder,
                    hasFile: values.hasFile ? 1 : 0,
                    hasAnswerKey: values.hasAnswerKey ? 1 : 0,
                    active: values.active ? 1 : 0
                };
                
                if(mode === 'create'){
                    response = await createLesson(lessonParams);
                } else if(mode === 'edit') {
                    lessonParams.id = lesson.id;
                    response = await updateLesson(lessonParams);
                }
            } else if(mode === 'delete') {
                response = await deleteLesson({ id: lesson.id });
            }

            const responseValid = checkResponse(response, mounted, setStatus);
            if(!responseValid && mounted.current){
                setSubmitting(false);
                return;
            }
            
            if(mounted.current) setSubmitted(true);
            setTimeout(() => handleClose(true), 1000);
        }
        submit();
    }, [mode, handleClose, lesson, createLesson, updateLesson, deleteLesson]);

    return (
        <Modal show={showModal} onHide={handleClose}>
            <Modal.Header>
                <h2>Lesson Form</h2>
            </Modal.Header>
            <LessonsBodyFooter
                mode={mode}
                selectedLesson={lesson}
                loaded={loaded}
                submitted={submitted}
                handleClose={handleClose}
                handleSubmit={handleSubmit}
            />
        </Modal>
    );
}

export default connect(null, {
    fetchLessonsId,
    createLesson,
    updateLesson,
    deleteLesson
})(LessonModal);